var map = {
	"./2026-06-16_v26.3.0.en.md": 791,
	"./2026-06-16_v26.3.0.fr.md": 792,
	"./2026-07-07_v26.4.0.en.md": 793,
	"./2026-07-07_v26.4.0.fr.md": 794,
	"./2026-07-15_v26.5.0.en.md": 795,
	"./2026-07-15_v26.5.0.fr.md": 796
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;